import * as React from 'react';

import { wrapWithTooltip } from '../wrap_with_tooltip';
import * as styles from './description_field.css';
import { Textarea } from '@cian/ui-kit';

interface IDescriptionFieldProps {
  isValid: boolean;
  className: string;
  value: string;
  change(e: React.ChangeEvent<HTMLTextAreaElement>, value: string): void;
}

export const maxDescriptionLength = 2000;

const DescriptionField = (props: IDescriptionFieldProps) => {
  const descriptionComponent: JSX.Element = (
    <div className={styles['description']}>
      <Textarea
        minRows={8}
        value={props.value}
        invalid={!props.isValid}
        maxLength={maxDescriptionLength}
        onChange={props.change}
      />
    </div>
  );

  return (
    <div className={props.className}>
      {props.isValid ? descriptionComponent : wrapWithTooltip(descriptionComponent, 'Заполните описание')}
    </div>
  );
};

export { DescriptionField };
